module.exports = __webpack_public_path__ + "static/media/Finnovex-West-Africa-2024.73e07ab6.png";